module.exports = __webpack_public_path__ + "static/media/menuUser.3d902bf0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/menuUser.svg
// module id = 487
// module chunks = 0